// extracted by mini-css-extract-plugin
export default {"currency_select":"currency_select___qhEY1","opened":"opened___urLgp","only_right_part":"only_right_part___jtFZI"};